module.exports = __webpack_public_path__ + "static/media/logo.8a1c2296.png";